import React, { useEffect, useState } from "react";
import { Wallet, Landmark, AlertTriangle, Users, Clock, FileCheck } from "lucide-react";
import api from "@/lib/api";
import { inr } from "@/lib/format";

const Stat = ({ icon: Icon, hi, en, value, tone, tid }) => (
  <div className="rounded-2xl bg-white p-4 shadow-sm border border-slate-100" data-testid={tid}>
    <div className={`inline-flex p-2 rounded-xl mb-2 ${tone}`}>
      <Icon className="h-5 w-5" />
    </div>
    <p className="text-lg font-mono font-bold">{value}</p>
    <p className="text-xs font-display font-semibold">{hi}</p>
    <p className="text-[10px] text-muted-foreground">{en}</p>
  </div>
);

export default function AdminHome({ setTab }) {
  const [stats, setStats] = useState(null);
  const [group, setGroup] = useState(null);
  const [deposits, setDeposits] = useState(0);

  useEffect(() => {
    (async () => {
      const [s, g, d] = await Promise.all([
        api.get("/admin/stats"),
        api.get("/group"),
        api.get("/admin/deposits"),
      ]);
      setStats(s.data);
      setGroup(g.data);
      setDeposits(d.data.filter((x) => x.status === "pending").length);
    })();
  }, []);

  if (!stats || !group) return <p className="text-center text-muted-foreground py-10">लोड हो रहा है…</p>;

  return (
    <div className="space-y-4">
      <div className="rounded-2xl bg-primary text-white p-5 shadow-lg">
        <p className="font-display font-bold text-xl">{group.name_hi}</p>
        <p className="text-white/75 text-sm">{group.name_en} · SHG</p>
        <div className="flex gap-4 mt-3 text-sm">
          <span className="flex items-center gap-1"><Users className="h-4 w-4" /> {group.total_members} सदस्य</span>
          <span className="flex items-center gap-1 text-emerald-200">● {group.regular} नियमित</span>
          <span className="flex items-center gap-1 text-red-200">● {group.defaulter} डिफॉल्टर</span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <Stat tid="stat-pool" icon={Wallet} hi="कुल पूल" en="Total Pool" value={inr(stats.total_pool)} tone="bg-blue-100 text-blue-700" />
        <Stat tid="stat-loans" icon={Landmark} hi="ऋण दिए" en="Loans Given" value={inr(stats.total_loans)} tone="bg-indigo-100 text-indigo-700" />
        <Stat tid="stat-default" icon={AlertTriangle} hi="डिफॉल्ट" en="NPA Amount" value={inr(stats.default_amount)} tone="bg-red-100 text-red-700" />
        <Stat tid="stat-active" icon={Users} hi="सक्रिय सदस्य" en="Active" value={`${stats.active_members}/${stats.total_members}`} tone="bg-emerald-100 text-emerald-700" />
      </div>

      <div className="grid grid-cols-2 gap-3">
        <button data-testid="quick-verify" onClick={() => setTab("verify")} className="flex items-center gap-3 rounded-2xl bg-white p-4 shadow-sm border border-slate-100 text-left">
          <div className="h-11 w-11 rounded-xl bg-amber-100 text-amber-700 flex items-center justify-center relative">
            <Clock className="h-5 w-5" />
            {deposits > 0 && <span className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-red-500 text-white text-[10px] flex items-center justify-center">{deposits}</span>}
          </div>
          <div>
            <p className="font-display font-semibold text-sm">सत्यापन</p>
            <p className="text-xs text-muted-foreground">{deposits} लंबित भुगतान</p>
          </div>
        </button>
        <button data-testid="quick-members" onClick={() => setTab("members")} className="flex items-center gap-3 rounded-2xl bg-white p-4 shadow-sm border border-slate-100 text-left">
          <div className="h-11 w-11 rounded-xl bg-blue-100 text-blue-700 flex items-center justify-center">
            <FileCheck className="h-5 w-5" />
          </div>
          <div>
            <p className="font-display font-semibold text-sm">सदस्य प्रबंधन</p>
            <p className="text-xs text-muted-foreground">सभी सदस्य देखें</p>
          </div>
        </button>
      </div>
    </div>
  );
}
